import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { TicketDetailView } from '@/features/ticket-detail/TicketDetailView'
import { AdminControls } from '@/features/ticket-admin/AdminControls'
import { useTicket } from '@/queries/tickets'
import { useIsAdmin } from '@/lib/auth'

function AdminGuard({ children }: { children: React.ReactNode }) {
  const isAdmin = useIsAdmin()
  const navigate = useNavigate()
  useEffect(() => {
    if (!isAdmin) navigate({ to: '/tickets' as never })
  }, [isAdmin, navigate])
  if (!isAdmin) return null
  return <>{children}</>
}

function AdminDetail() {
  const { id } = Route.useParams()
  const { data } = useTicket(id)
  return (
    <AdminGuard>
      <TicketDetailView
        ticketId={id}
        adminControls={data ? <AdminControls ticket={data.ticket} /> : null}
        showInvestigations
      />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/admin/tickets/$id')({ component: AdminDetail })
